import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PageHero from '../components/PageHero';

const { FiHeart, FiUsers, FiBriefcase, FiArrowUpRight } = FiIcons;

const actions = [
  {
    icon: FiHeart,
    title: 'Give',
    text: 'Help provide materials, mentorship opportunities, transportation, and program experiences.',
    label: 'Discuss a contribution',
    subject: 'Supporting Legacy of Immortals'
  },
  {
    icon: FiUsers,
    title: 'Volunteer',
    text: 'Share your time at community events, outreach activities, or youth learning experiences.',
    label: 'Become a volunteer',
    subject: 'Volunteer interest'
  },
  {
    icon: FiBriefcase,
    title: 'Partner',
    text: 'Create workforce exposure and expand opportunities through corporate or community partnership.',
    label: 'Start a partnership',
    subject: 'Partnership inquiry'
  }
];

function GetInvolved() {
  return (
    <>
      <PageHero
        eyebrow="Get involved"
        title="Your support becomes someone’s next opportunity."
        text="Individuals, volunteers, businesses, and community organizations all have a role in building a stronger path forward."
        image="/images/5.jpg"
      />
      <section className="involvement-grid">
        {actions.map((action) => (
          <article key={action.title}>
            <SafeIcon icon={action.icon} />
            <h2>{action.title}</h2>
            <p>{action.text}</p>
            <a href={`mailto:info@example.com?subject=${encodeURIComponent(action.subject)}`}>
              {action.label} <SafeIcon icon={FiArrowUpRight} />
            </a>
          </article>
        ))}
      </section>
      <section className="contact-panel">
        <div>
          <p className="eyebrow">Start a conversation</p>
          <h2>Have an idea for making a difference?</h2>
        </div>
        <div>
          <p>Tell us how you would like to support young people across the Pacific Northwest. We would be glad to explore what is possible together.</p>
          <a className="primary-button" href="mailto:info@example.com?subject=Legacy%20of%20Immortals%20inquiry">
            Email our team <SafeIcon icon={FiArrowUpRight} />
          </a>
        </div>
      </section>
    </>
  );
}

export default GetInvolved;